var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(!_vm.isKeepAlive)?_c('router-view'):_vm._e(),_c('keep-alive',[(_vm.isKeepAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }